module.exports = __webpack_public_path__ + "static/media/spiderman-text.438fde76.png";